import { X } from "lucide-react";

// Removable indicator for a temporary contextual view opened from the Dashboard
// (single-element focus or "see all"). Does NOT touch persisted user preferences.
export function ContextBanner({ label, onClear, testid }) {
  return (
    <div
      data-testid={testid}
      className="flex items-center gap-2 rounded-full bg-[#FEF3C7] border border-[#FCD34D] px-3 py-1.5 text-sm text-[#92400E] w-fit max-w-full"
    >
      <span className="truncate">Mostrando: {label}</span>
      <button
        type="button"
        onClick={onClear}
        data-testid={`${testid}-clear`}
        className="shrink-0 rounded-full hover:text-[#B91C1C] transition-colors"
        aria-label="Chiudi vista contestuale"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
